"use strict";
/**
 * v-on-native directive
 *
 * Attaches an event listener that fires when the native DOM event on the element fires.
 * This directive emulates what v-on.native used to do in Vue 2.
 *
 * Vue 3 changed how event listeners are attached to component elements, in my opinion, for the worse.
 * Whether or not a native event listener is attached is completely up to the child component now,
 * which takes a lot of control away from the application when using component libraries.
 *
 * Syntax:
 * v-on-native.eventname="callbackMethod"
 * v-on-native.eventname.capture="callbackMethod" --> Enables "capture" on event listener (runs before children)
 * v-on-native.eventname="{ callback: callbackMethod, args: ['additional', 'callback', 'arguments'] }"
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.onNativeDirective = void 0;
const eventListenerMap = new WeakMap();
function normalizeInput(binding) {
    const modifiers = Object.assign({}, binding.modifiers);
    const useCapture = modifiers.capture || false;
    delete modifiers.capture;
    const eventName = Object.keys(modifiers)[0];
    const callbackOrObject = binding.value;
    let callback = callbackOrObject;
    let callbackArgs = [];
    if (callbackOrObject === null || callbackOrObject === void 0 ? void 0 : callbackOrObject.callback) {
        callback = callbackOrObject.callback;
        callbackArgs = callbackOrObject.args || [];
    }
    return { eventName, useCapture, callback, callbackArgs };
}
function modifyListeners(el, binding, isAdd) {
    const { eventName, useCapture, callback, callbackArgs } = normalizeInput(binding);
    const eventListeners = eventListenerMap.get(el) || {};
    const existingEventListener = eventListeners[eventName];
    if (existingEventListener) {
        el.removeEventListener(eventName, existingEventListener, useCapture);
    }
    if (isAdd) {
        const wrappedCallback = (event) => {
            callback.call(window, event, ...callbackArgs);
        };
        el.addEventListener(eventName, wrappedCallback, useCapture);
        eventListeners[eventName] = wrappedCallback;
    }
    eventListenerMap.set(el, eventListeners);
}
exports.onNativeDirective = {
    beforeMount(el, binding) {
        modifyListeners(el, binding, true);
    },
    updated(el, binding) {
        modifyListeners(el, binding, true);
    },
    unmounted(el, binding) {
        modifyListeners(el, binding, false);
    }
};
//# sourceMappingURL=on-native.js.map